import { noAccessReason, type WebPermission } from '@dawn/feature-config';
import { Card, CardDescription, CardHeader, CardTitle } from '@dawn/ui';
import { Lock } from 'lucide-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { usePermissions } from '@/hooks/use-permissions';
import { refreshSessionUser } from '@/lib/api';

/** Shown in place of an area the session user lacks `permission` for (TDEV-1213). */
export function NoAccess({ permission }: { permission: WebPermission }) {
  const { key } = useLocation();
  // Re-check on mount and on every navigation while the panel shows, so a role
  // granted meanwhile opens the page on the next click.
  useEffect(() => void refreshSessionUser(), [key]);
  const { can } = usePermissions();
  const reason = noAccessReason(permission, can);

  return (
    <Card className="mx-auto mt-16 max-w-md text-center" data-testid="no-access">
      <CardHeader className="items-center">
        <Lock className="size-8 text-muted-foreground" aria-hidden />
        <CardTitle>You don&apos;t have access to this area</CardTitle>
        <CardDescription>{reason}</CardDescription>
      </CardHeader>
    </Card>
  );
}
